









































import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "support-departments-provider": () =>
      import(
        "@/components/app/admin/settings/supportDepartments/supportDepartmentsProvider.vue"
      ),
    "support-departments-items": () =>
      import(
        "@/components/app/admin/settings/supportDepartments/supportDepartmentsItems.vue"
      )
  }
})
export default class SupportDepartmentsListing extends Vue {}
